const textColor = (editor, { value: color }) => {
  editor.chain().focus().setColor(color).run();
};

export default {
  'text:color': textColor,
};
